import { apiClient } from 'lib/apiClient';
import { useQuery } from 'react-query';

const useGetReports = () => {
  return useQuery(['asdf'], () => {
    return apiClient.internalReports.get({ frequency: 'monthly' });
  });
};

export { useGetReports };
